// @flow
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { withLeaflet } from 'react-leaflet';
import { withRouter } from 'react-router';
import { Box } from 'grommet';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import PolygonRoutes from './PolygonRoutes';

const POLYGON_PANEL_ID = 'POLYGON_PANEL_ID';


const PolygonRoutesContainer = () => {
    const [attributes, setAttributes] = useState(null);

    const getAttributes = (attribute) => {
        setAttributes({ ...attributes, ...attribute });
    };

    return (
        <SidePane
            id={POLYGON_PANEL_ID}
            openInitially
            title={(<FormattedMessage id="polygon-routes-title" defaultMessage="Create polygon" />)}
        >
            <Box height="100%">
                <PolygonRoutes
                    attributes={attributes}
                    getAttributes={!attributes ? getAttributes : null}
                />
            </Box>
        </SidePane>
    );
};

export default withRouter(withLeaflet(PolygonRoutesContainer));
